<app-modal
  *ngIf="mainContent && secondaryAction && primaryAction"
  [modalTitle]="'profile.qualificationSummaryTitle'"
  [mainContentTemplate]="mainContent"
  [secondaryActionTemplate]="secondaryAction"
  [primaryActionTemplate]="primaryAction"
  [scrollableBody]="true"
  (closed)="activeModal.dismiss()"
></app-modal>

<ng-template #mainContent>
  <app-qualification-tab [entity]="entity"></app-qualification-tab>
</ng-template>

<ng-template #secondaryAction>
  <button
    class="btn btn-falcon-default btn-sm me-3"
    type="button"
    (click)="handleSecondaryAction()"
  >
    {{ "profile.reQualify" | translate }}
  </button>
</ng-template>

<ng-template #primaryAction>
  <button
    class="btn btn-primary btn-sm"
    type="button"
    (click)="handlePrimaryAction()"
  >
    {{ "general.close" | translate }}
  </button>
</ng-template>
